import t from"react";import{MUIAccordionDetails as e}from"./styles.js";const r=({details:r})=>t.createElement(e,null,r);export{r as default};
//# sourceMappingURL=AccordionDetails.js.map
